module.exports = __webpack_public_path__ + "img/startingpoint_logo.072fbb2d.png";